
import BaseFilter from '@/components/filters/Filter';

export default BaseFilter.extend({
	props: {
		value: {
			type: Object as () => {
				[value: string]: boolean;
			},
			required: true,
			default: () => ({})
		}
	},
	methods: {
		toggleCheckbox(value: string, checked: boolean) {
			this.e_input({
				...this.value,
				[value]: checked
			});
		},
	},
});

